import React from 'react';
import Section from '../layout/Section';
import Maps from '../components/Maps';

const Locations = () => {
  return (
    <React.Fragment>
      <Section s1>
        <Maps />
      </Section>
    </React.Fragment>
  );
};

export default Locations;
